import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getColorForScore } from "../../services/detect";

interface CircularProgressProps {
	value: number; // 0-1
	textHidden?: boolean;
}

export function CircularProgress({ value, textHidden }: CircularProgressProps) {
	const percentage = Math.round(value * 100);
	const color = getColorForScore(value);

	return (
		<CircularProgressbar
			value={percentage}
			text={textHidden ? "" : `${percentage}%`}
			styles={buildStyles({
				pathColor: color,
				textColor: "#262626",
			})}
		/>
	);
}
